import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalAgentCertificate } from '../../core/services/local-agent.service';

export interface TokenFisicoSelectCertForResetData {
  certificates: LocalAgentCertificate[];
}

export interface TokenFisicoSelectCertForResetResult {
  certificate: LocalAgentCertificate;
}

@Component({
  selector: 'app-token-fisico-select-cert-for-reset',
  templateUrl: './token-fisico-select-cert-for-reset.component.html',
  styleUrls: ['./token-fisico-select-cert-for-reset.component.css'],
  standalone: false
})
export class TokenFisicoSelectCertForResetComponent {
  selectedCertificate: LocalAgentCertificate | null = null;

  constructor(
    public dialogRef: MatDialogRef<TokenFisicoSelectCertForResetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TokenFisicoSelectCertForResetData
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  selectCertificate(cert: LocalAgentCertificate): void {
    this.selectedCertificate = cert;
  }

  confirmSelection(): void {
    if (this.selectedCertificate) {
      this.dialogRef.close({ certificate: this.selectedCertificate });
    }
  }

  displayName(cert: LocalAgentCertificate): string {
    return cert.friendlyName || this.extractCN(cert.subjectDN) || cert.thumbprint || 'Certificado';
  }

  private extractCN(subjectDN?: string): string | null {
    if (!subjectDN) return null;
    const match = subjectDN.match(/CN=([^,]+)/i);
    return match ? match[1].trim() : null;
  }

  getCertificateType(cert: LocalAgentCertificate): { label: string; cssClass: string } | null {
    const ou = this.extractOU(cert.subjectDN);
    if (!ou) return null;
    const ouLower = ou.toLowerCase();
    if (ouLower.includes('token fisico') || ouLower.includes('Certifirma Digital Físico')) {
      return { label: 'Certifirma Digital Físico', cssClass: 'badge-fisico' };
    }
    if (ouLower.includes('Certifirma Digital Virtual')) {
      return { label: 'Certifirma Digital Virtual', cssClass: 'badge-virtual' };
    }
    return { label: ou, cssClass: 'badge-otro' };
  }

  private extractOU(subjectDN?: string): string | null {
    if (!subjectDN) return null;
    const match = subjectDN.match(/OU=([^,]+)/i);
    return match ? match[1].trim() : null;
  }

  formatSerial(serial?: string): string {
    if (!serial) return '';
    if (serial.length <= 8) return serial;
    return '...' + serial.slice(-8).toUpperCase();
  }

  extractIssuerName(issuerDN?: string): string {
    if (!issuerDN) return '';
    const cnMatch = issuerDN.match(/CN=([^,]+)/i);
    const oMatch = issuerDN.match(/O=([^,]+)/i);
    const cn = cnMatch ? cnMatch[1].trim() : '';
    const o = oMatch ? oMatch[1].trim() : '';
    if (cn && o) return `${cn} - ${o}`;
    return cn || o || issuerDN;
  }

  formatDate(dateStr?: string): string {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('es-CO', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return dateStr;
    }
  }
}
